import {
	Component,
	Input,
	ViewChild,
	ElementRef,
	AfterViewInit
} from "@angular/core";
import { DodoBaseButtonComponent } from "../dodo-base-button/dodo-base-button.component";

@Component({
    selector: "dodo-raised-button",
    templateUrl: "./dodo-raised-button.component.html",
    styleUrls: ["./dodo-raised-button.component.scss"],
    standalone: false
})
export class DodoRaisedButtonComponent extends DodoBaseButtonComponent
	implements AfterViewInit {
	@Input()
	busy = false;
	@Input()
	spinnerColor = "primary";
	@Input()
	contentPadding = 20;
	@Input() width?: string;

	@ViewChild("button", { static: true })
	button: ElementRef;

	constructor() {
		super();
	}

	ngAfterViewInit() {
		// this.button.nativeElement.focus();
	}
}
